module.exports = __webpack_public_path__ + "static/media/rockclimbing.635f427c.webp";